export default __webpack_public_path__ + "static/media/logo.592a4edd.svg";